export const hitDetectionToCorner = (
  itemDimensions,
  relativePoint,
  offset,
) => {
  if (relativePoint.x < -3 || relativePoint.y < -3) return null

  if (relativePoint.x <= offset && relativePoint.y <= offset) return 'top-left'

  if (
    relativePoint.x <= itemDimensions.width + 3 &&
    relativePoint.x >= itemDimensions.width - offset &&
    relativePoint.y <= offset
  )
    return 'top-right'

  if (
    relativePoint.x <= offset &&
    relativePoint.y <= itemDimensions.height + 3 &&
    relativePoint.y >= itemDimensions.height - offset
  )
    return 'bottom-left'

  if (
    relativePoint.x <= itemDimensions.width + 3 &&
    relativePoint.x >= itemDimensions.width - offset &&
    relativePoint.y <= itemDimensions.height + 3 &&
    relativePoint.y >= itemDimensions.height - offset
  )
    return 'bottom-right'

  return null
}

export const hitDetectionToRect = (
  itemDimensions,
  relativePoint,
) =>
  relativePoint.x >= 0 &&
  relativePoint.x <= itemDimensions.width &&
  relativePoint.y >= 0 &&
  relativePoint.y <= itemDimensions.height

export const hitDetectionToCircle = (
  centerPont,
  absolutePoint,
  radius,
) =>
  ((centerPont.x - absolutePoint.x) ** 2 + (centerPont.y - absolutePoint.y) ** 2) ** (1 / 2) <=
  radius

export const hitDetectionToLine = (
  itemDimensions,
  relativePoint,
  radius,
) => {
  let { width, height } = itemDimensions
  let { x, y } = relativePoint

  if (width < 0) {
    x *= -1
    width *= -1
  }

  if (height < 0) {
    y *= -1
    height *= -1
  }

  if (height === 0) return Math.abs(y) < radius
  if (width === 0) return Math.abs(x) < radius

  if (x < 0 - radius || x > width + radius || y < 0 - radius || y > height + radius) return false

  const a = height / width
  const firstPointY = a * x
  const secondPointX = y / a

  const dx = Math.abs(x - secondPointX)
  const dy = Math.abs(y - firstPointY)

  if (dx === 0 && dy === 0) return false

  const h = (dx * dy) / (dx ** 2 + dy ** 2) ** (1 / 2)
  return h <= radius
}

export const hitDetectionToCursor = (
  selectedItem,
  canvas,
  absolutePoint,
) => {
  const boundary = selectedItem.getBoundary()
  const relativePoint = {
    x: absolutePoint.x - boundary.x,
    y: absolutePoint.y - boundary.y,
  }

  const checkDetectionToRect = hitDetectionToRect(
    {
      width: boundary.width,
      height: boundary.height,
      angle: 0,
    },
    relativePoint,
  )
  if (!checkDetectionToRect) return false

  const { text, cursorPosition } = selectedItem.getParams()
  if (!text || cursorPosition === undefined) return false

  const params = { text, cursorPosition }
  let checkDetectionToChar = false
  let textLength = 0

  const lines = text.split('/n')
  lines.forEach((line, lineIndex) => {
    if (checkDetectionToChar) return

    //check current line
    if (lineIndex * 24 > relativePoint.y || (lineIndex + 1) * 24 < relativePoint.y) {
      textLength += line.length + 2
      return
    }

    const ctx = canvas.getContext('2d')
    const lineWidth = ctx.measureText(line).width

    const widthDifference = relativePoint.x - lineWidth

    //check cursor position under text
    if (widthDifference > 10) return

    //check cursor in end of line
    if (widthDifference > 0 && widthDifference < 10) {
      checkDetectionToChar = true
      params.cursorPosition = textLength + line.length
      return
    }

    //search position into line
    let str = ''
    line.split('').forEach((char, charIndex) => {
      if (checkDetectionToChar) return
      str += char

      const charsWidth = ctx.measureText(str).width
      if (charsWidth < relativePoint.x) return

      params.cursorPosition = textLength + charIndex
      checkDetectionToChar = true
    })
  })

  if (checkDetectionToChar) selectedItem.setParams(params)

  return checkDetectionToChar
}

export const resizeTextBoundary = (text, ctx) => {
  const lines = text.split('/n')
  let maxWidth = 0
  const maxHeight = 24 * lines.length

  lines.forEach(line => {
    const width = ctx.measureText(line).width
    if (width > maxWidth) maxWidth = width
  })

  return {
    width: maxWidth,
    height: maxHeight,
  }
}

export const resizeToMinBoundary = (item, minWidth, nimHeight) => {
  const boundary = item.getBoundary()
  if (boundary.width >= minWidth && boundary.height >= nimHeight) return

  item.setBoundary({
    x: boundary.x,
    y: boundary.y,
    width: boundary.width >= minWidth ? boundary.width : minWidth,
    height: boundary.height >= nimHeight ? boundary.height : nimHeight,
    angle: boundary.angle,
  })
}



// WEBPACK FOOTER //
// ./src/drawing/utils/index.js